import { useCanvasStore } from '@/pages/canvas/canvas-store';
import { CanvasSidebar } from '@/pages/canvas/canvas-sidebar';
import { ChevronRight } from 'lucide-react';

/**
 * Page chrome for non-canvas pages (e.g. Dev Tools entries like Redesign,
 * Ad Copy, Create Ads, Mock Data) that should share the new canvas-style
 * sidebar.
 *
 * The sidebar's open/collapsed state is held in the shared `useCanvasStore`
 * so it stays consistent as the user navigates between pages.
 */
export function CanvasShell({ children }: { children: React.ReactNode }) {
  const { isSidebarOpen, isSidebarCollapsed, toggleSidebar } = useCanvasStore();
  const sidebarWidth = isSidebarOpen ? (isSidebarCollapsed ? 60 : 270) : 0;

  return (
    <div
      className="flex h-screen overflow-hidden bg-[#EBEBEB]"
      style={{ letterSpacing: '-0.01em', WebkitFontSmoothing: 'antialiased' } as React.CSSProperties}
    >
      <div
        className="relative flex-shrink-0 h-full overflow-hidden transition-all duration-[250ms] ease-in-out"
        style={{ width: sidebarWidth }}
      >
        <CanvasSidebar />
      </div>

      {!isSidebarOpen && (
        <button
          data-testid="canvas-shell-sidebar-expand"
          onClick={toggleSidebar}
          className="absolute top-4 left-2 z-20 w-8 h-8 bg-white border border-[#E8E5E0] rounded-lg flex items-center justify-center text-[#8C8C8C] hover:text-[#1A1A1A] shadow-sm transition-colors"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      )}

      <div className="flex-1 min-w-0 overflow-hidden bg-white">
        {children}
      </div>
    </div>
  );
}
